import { Component, Inject, OnInit, Optional } from '@angular/core';
import { BaseComponent } from '../../shared/base-components/base.component';
import { SelectItem } from 'primeng/api';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { CustomerManageService } from '../shared/customer-manage.service';
import { CustomerContact } from '../models/customer-contact.model';
import { ContactMethodType } from '../models/enums/contact-method-type.enum';
import { CustomerSurveyService } from '../shared/customer-survey.service';

@Component({
    templateUrl: './send-customer-survey-modal.component.html'
})
export class SendCustomerSurveyModalComponent extends BaseComponent implements OnInit {

    customerNumberId: number;
    customerContactId: number;
    customerContacts: CustomerContact[];
    languageCode: 'en' | 'es' = 'en';
    languageCodeOptions: SelectItem[] = [
        {
            label: 'English',
            value: 'en'
        },
        {
            label: 'Spanish',
            value: 'es'
        }
    ];
    inProgress = false;

    private contactMethodType = new ContactMethodType();

    constructor(
        public dialogRef: MatDialogRef<SendCustomerSurveyModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: number,
        private customerSurveyService: CustomerSurveyService,
        private customerManageService: CustomerManageService
    ) {
        super();
        this.customerNumberId = data;
    }

    ngOnInit() {
        this.customerManageService.getCustomerContacts(this.customerNumberId).subscribe({
            next: contacts => {
                this.customerContacts = contacts;
            },
            error: error => {
                this.handleValidationResult(error);
            }
        });
    }

    onSubmitClicked(): void {
        this.inProgress = true;
        this.customerSurveyService.sendCustomerSurvey(this.customerNumberId, this.customerContactId, this.languageCode).subscribe({
            next: _ => {
                this.close();
                this.inProgress = false;
            },
            error: error => {
                this.handleValidationResult(error);
                this.inProgress = false;
            }
        });
    }

    close() {
        this.dialogRef.close();
    }
}
